import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';

const TermsOfService = () => {
    return (
        <Layout>
            <Helmet>
                <title>Terms of Service - MyEnAb</title>
                <meta name="description" content="Terms of Service for MyEnAb platform." />
            </Helmet>
            <div className="max-w-4xl mx-auto px-4 py-12 text-zinc-300">
                <h1 className="text-4xl font-lexend font-bold text-white mb-8">Terms of Service</h1>
                <div className="space-y-6 text-lg">
                    <p>Last updated: {new Date().toLocaleDateString()}</p>
                    
                    <h2 className="text-2xl font-bold text-white mt-8">1. Acceptance of Terms</h2>
                    <p>By accessing MyEnAb, you agree to comply with these Terms of Service and all applicable laws and regulations, including international data protection standards (GDPR) and state privacy acts (CCPA). If you do not agree, you are prohibited from using the platform.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">2. Privacy & Data Processing</h2>
                    <p>Your use of MyEnAb is also governed by our <strong>Privacy Policy</strong>. By using the platform, you acknowledge the processing of your personal data as described therein, including any health-related or disability data you choose to share for community connection purposes.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">3. User Conduct & Content</h2>
                    <p>You are responsible for the content you post. MyEnAb is an inclusive space; hate speech, discrimination, or harassment based on disability, race, gender, or orientation will result in immediate account termination.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">4. Use License</h2>
                    <p>Permission is granted to use MyEnAb for personal, community-focused purposes. You may not reverse engineer the software, scrape data, or use the platform for unauthorized commercial solicitation.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">5. Account Termination</h2>
                    <p>We reserve the right to suspend or terminate accounts that violate these terms. Upon termination, your right to use the platform ceases immediately. You may request your data export prior to deletion in accordance with our Privacy Policy.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">6. Disclaimer & Liability</h2>
                    <p>MyEnAb is provided "as is". While we strive for absolute data security via PII encryption, we are not liable for user-generated content or service interruptions. We do not provide medical advice; always consult a professional for health-related concerns.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">7. Governing Law</h2>
                    <p>These terms are governed by the laws of the jurisdiction in which MyEnAb operates, without regard to its conflict of law provisions, and subject to applicable international privacy regulations.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">8. Contact</h2>
                    <p>Questions about these terms? Reach out to <strong>legal@myenab.com</strong>.</p>
                </div>
            </div>
        </Layout>
    );
};

export default TermsOfService;
